import React from 'react';
import { Award, DollarSign, Shield, MapPin, Building2, Trophy } from 'lucide-react';
import { whyChooseUs, businessInfo } from '../mockData';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Award: Award,
  DollarSign: DollarSign,
  Shield: Shield,
  MapPin: MapPin,
  Building2: Building2,
  Trophy: Trophy
};

const About = () => {
  return (
    <section id="about" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Why Choose <span className="text-orange-600">All-Out Moving</span>?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Based in Mishicot, Wisconsin, we've been providing professional moving and junk removal services to our community and surrounding areas since 2019. As a licensed carrier (DOT# 3310412) registered with FMCSA, we bring experience, reliability, and care to every job.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Proud member of the Chamber of Commerce for 2 years and honored to be elected Best of the Lakeshore Business for 5 consecutive years, we're committed to excellence in service and customer satisfaction.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our team is dedicated to making your moving experience stress-free and efficient. Whether you're moving across town or need junk removal or small demolition services, we handle every project with the same level of professionalism and attention to detail.
            </p>
            
            <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-orange-600">
              <h3 className="font-bold text-gray-900 mb-2 text-lg">Our Mission</h3>
              <p className="text-gray-700">
                To provide accurate, affordable, and trustworthy services that exceed our customers' expectations while building lasting relationships in our community.
              </p>
            </div>
          </div>

          {/* Right Content - Feature Cards */}
          <div className="grid sm:grid-cols-2 gap-6">
            {whyChooseUs.map((item) => {
              const IconComponent = iconMap[item.icon];
              return (
                <Card key={item.id} className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-orange-200">
                  <CardContent className="pt-6">
                    <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                      <IconComponent className="text-orange-600 group-hover:text-white transition-colors duration-300" size={28} />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Service Areas */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Areas We Serve</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {businessInfo.serviceAreas.map((area, index) => (
              <div 
                key={index}
                className="px-6 py-3 bg-orange-50 text-orange-700 font-semibold rounded-full border-2 border-orange-200 hover:bg-orange-100 transition-colors"
              >
                {area}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
